import React, {useState} from 'react'
import {  Form, Header, Input, Radio,Message, Button } from 'semantic-ui-react'

import DatePicker from "react-datepicker";
 
import "react-datepicker/dist/react-datepicker.css";

import es from 'date-fns/locale/es';

// import { useAlert } from "react-alert";

export   function Step1a_Edit(props) {



   const [date, setDate] = useState({ age:props.age})
   let dob = Date.parse(props.dob)
   const [dt, setDt] = useState({dob: dob})
 
//    let converted_dob = timeConverter(dob)

   const [state, setState] = useState({value:props.gender, title: "", name:"", mrn:"", gender:""})

   const [title, setTitle] = useState()





   let dateInput = React.createRef();
    if (props.currentStep !== 1) {
        return null
    } 
    // const state = {}
 


    const calculate_age = (dob1) => {
        var today = new Date();
        var birthDate = new Date(dob1);  // create a date object directly from `dob1` argument
        if(dob1 == null){
            return
        }

        // console.log(dob1)

        var age_now = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        // if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) 
        // {
        //     age_now--;
        // }

        if (age_now.toString().length < 4 && age_now > -1 ){
            // console.log(age_now);
            // setState({ age_now })
            setDate({ age: age_now })

            const event = {target:{name:'age', value:age_now}}
            props.handleChange(event)
        }
        
        
       
        return age_now;
      }


    // const handleAge = () => {
    //     // e.preventDefault();
    //     console.log(date.age)
    //     const event = {target:{name:'age', value:date.age}}
    //     props.handleChange(event)
            
    // }

 


 
    const handleDob = (date)=>{
        calculate_age(date)
        setDt({dob:date})
        const event = {target:{name:'dob', value:date}}
        props.handleChange(event)
        // handleAge()
    }


    const handleGender = (e, { value })=>{
      setState({ value })
      const event = {target:{name:'gender', value:value}}
      props.handleChange(event)

  }


    const clearDob=(e)=>{
        e.preventDefault();
        setDate({ age: "" })
        setDt({dob:''})
    }


    const handleTitle = ()=>{
      let mrn = ''
      if (props.mrn) {
        mrn = 'MRN#' + ' ' +  (props.mrn) 
      }
      let titleMrn =   (date.age)+' ' + (props.gender)  + ' ' + (props.name) +' '+ (mrn) 
      setTitle(titleMrn)

      const event = {target:{name:'title', value:titleMrn}}
      props.handleChange(event)

  }
    
//   function timeConverter(UNIX_timestamp){
//     var a = new Date(UNIX_timestamp * 1000);
//     var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
//     var year = a.getFullYear();
//     var month = months[a.getMonth()];
//     var date = a.getDate();
//     var hour = a.getHours();
//     var min = a.getMinutes();
//     var sec = a.getSeconds();
//     var time = date + ' ' + month + ' ' + year + ' ' + hour + ':' + min + ':' + sec ;
//     return time;
//   }
 

    const ShowTitle=()=>{
    
      let mrn = ''

    //   let dob = Date.parse(props.dob)
    //   let converted_dob = timeConverter(dob)
      if (props.mrn) {
        mrn = 'MRN#' + ' ' +  (props.mrn) 
      }
      let title =   (date.age)+' ' + (props.gender)  + ' ' + (props.name) +' '  + ' ' 
      let titleMrn =   (date.age)+' ' + (props.gender)  + ' ' + (props.name) +' '+ (mrn) 

      
      // setTitle(titleMrn)
      // handleTitle(titleMrn)
      // setState({title:titleMrn })
      // let titleMrn =   (date.age)+' ' + (props.gender)  + ' ' + (props.name) +' '+ (mrn) 

      return(
       <Message  textAlign='center' style={{  background: "transparent"}}> 
  {title}
       
       {mrn}

       </Message>
       
      )
    }



    // useState({value:"", title: "", name:"", mrn:"", gender:""})
    return(

        // :Patient MR#DOB:
        
        <div className="form-group"   style={{textAlign:'center'}}>
        {/* <Header as='h1' textAlign='center'>Healthcare Brief</Header> */}

        
         <Form.Field  style={{textAlign:'center'}}>
                      {/* <label>User Input</label> */}   

                      
        <Header textAlign='center'>TITLE</Header>
        {/* < Input id='title' name='title' placeholder='Please enter a project title...' onChange={props.handleChange}  value={(props.title) + (props.description)} /> */}

 
        <Message style={{background: "transparency",   border: "1px solid transparent"}}>
    {/* <Message.Header>{ (state.value) + ' ' +  (props.title) +' ' + (props.description) + ' ' }</Message.Header> */}
            <Message.Header style={{textAlign:"center"}}>
            {/* {(date.age)+' ' + (props.gender)  + ' ' + (props.name) +' '+ 'MRN#' + ' ' +  (props.mrn) } */}
            <ShowTitle  textAlign='center' />
            </Message.Header>
        </Message>

      

        <Header textAlign='center'>PATIENT NAME</Header>
        <Form.Field control='textarea' 
                   style={{textAlign:'center'}} rows='1.2'  name='name' placeholder='Patient Name' onChange={props.handleChange}  value={props.name} />


        <Header textAlign='center'>MRN</Header>
        <Form.Field  control='textarea' 
                   style={{textAlign:'center'}} rows='1.2' name='mrn' placeholder='Patient Mrn' onChange={props.handleChange}  value={props.mrn} />

 


        <Header textAlign='center'>DOB</Header>
 
        <DatePicker
 
        name='dob'
        selected={dt.dob}
        onChange={handleDob }
        // isClearable ={clearDob
        dateFormat="yyyy/MM/dd"
        placeholderText="yyyy/MM/dd"
      >
      
      {/* <input  hidden name="age" onChange={handleAge}  value={props.age} ></input> */}
      </DatePicker>

      <Button onClick={clearDob}> Clear </Button>

        </Form.Field>
  
        <Header textAlign='center'>M/F</Header>
        <Form.Field>
          Selected gender: <b>{state.value}</b>
        </Form.Field>
        <Form.Field>
          <Radio
            label='Female'
            name='radioGroup'
            value='Female'
            checked={state.value === 'Female'}
            onChange={handleGender}
          />
        </Form.Field>
        <Form.Field>
          <Radio
            label='Male'
            name='radioGroup'
            value='Male'
            checked={state.value === 'Male'}
            onChange={handleGender}
          />
        </Form.Field>


        <Header textAlign='center' >what would you like to add?</Header>

        <Form.Field onChange={props.handleChange}  value={props.description} id='description' name='description' label='' control='textarea' 
                   style={{textAlign:'center'}}          rows='3.2' placeholder='A description of the project and description for your team' />

 




        <br></br><br></br>     <br></br><br></br> <br></br><br></br>


 
 
      </div>
    );
    }
    

